module.exports = new __parcel__URL__("Inner-Harbor-skyline-Baltimore-Maryland-banner.8d5e3d59.jpg").toString();